import { Provision } from "lib/static/options"

export const disabilityProvisionSrc = (provision: Provision): string => {
  switch (provision) {
    case "Geschikt voor Doven/Slechthorenden":
      return "/suitable_for_deaf.png"
    case "Gebarentolk":
      return "/sign_language-interpretor.png"
    case "Geschikt voor Blinden/Slechtzienden":
      return "/suitable_for_blind.png"
    case "Rolstoeltoegankelijk":
      return "/wheelchair.png"
    case "Ontprikkelruimte":
      return "/low_stimulus_representation.png"
    case "Voorstellingen met Schrijftolk":
      return "/writing_interpreter.png"
    case "Goed te Bereiken met OV":
      return "/public_transportation.png"
    case "Audio Descriptie":
      return "/audio_description.png"
    case "Goed te Bereiken met De Auto":
      return "/car.png"
    case "Ook Online bij Te Wonen":
      return "/online.png"
    case "Triggerwarning":
      return "/trigger-warning.png"
    default:
      return "/wheelchair.png"
  }
}
